<agpr-take-over-panel
    id="agpr_canvasLoadingPanel"
    class="agpr-canvasLoadingPanel"
    [splitHeader]="panelHeader"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    (visibleChange)="handleVisibleChange($event)"
    [minPanelWidth]="480"
    [maxPanelWidth]="600"
    [responsiveWidth]="true"
>
    <div class="agpr-canvasLoadingPanel-content">
        <agpr-message
            class="agpr-canvasLoadingPanel-infoBanner"
            [severity]="messageSeverityEnum.info"
        >
            {{ 'Briefings.newBriefing.naturalLanguage.loadingDialog.message' | localize }}
        </agpr-message>

        @for (step of steps; track step.id; let i = $index) {
            @if (i === 0 || steps[i - 1].status === 'complete') {
                <div
                    class="agpr-canvasLoadingPanel-step"
                    [class.agpr-canvasLoadingPanel-step--complete]="step.status === 'complete'"
                    [class.agpr-canvasLoadingPanel-step--inProgress]="step.status === 'in_progress'"
                    [class.agpr-canvasLoadingPanel-step--pending]="step.status === 'pending'"
                >
                    <div class="agpr-canvasLoadingPanel-stepHeader">
                        <div class="agpr-canvasLoadingPanel-stepLabel">
                            {{ step.labelKey | localize }}
                        </div>
                        <div class="agpr-canvasLoadingPanel-stepIcon">
                            @if (step.status === 'complete') {
                                <i class="fa-duotone fa-regular fa-circle-check agpr-canvasLoadingPanel-iconComplete"></i>
                            } @else if (step.status === 'in_progress' && !step.topics?.length) {
                                <div
                                    [agprLoading]="true"
                                    [loadingSmallIndicator]="true"
                                    class="agpr-canvasLoadingPanel-spinner"
                                ></div>
                            } @else if (step.status === 'pending') {
                                <i class="fa-regular fa-circle agpr-canvasLoadingPanel-iconPending"></i>
                            }
                        </div>
                    </div>

                    @if (step.topics?.length) {
                        <div class="agpr-canvasLoadingPanel-topics">
                            @for (topic of step.topics; track topic.key) {
                                <div class="agpr-canvasLoadingPanel-topic">
                                    <div class="agpr-canvasLoadingPanel-topicContent">
                                        <div class="agpr-canvasLoadingPanel-topicHeader">{{ topic.name }}</div>
                                        <div class="agpr-canvasLoadingPanel-topicMessage">
                                            {{ (topic.activity | localize) || ('Briefings.newBriefing.naturalLanguage.loadingPanel.topic.searchingInternet' | localize) }}
                                        </div>
                                    </div>
                                    <div class="agpr-canvasLoadingPanel-topicStatus">
                                        @if (topic.status === 'complete') {
                                            <i class="fa-duotone fa-regular fa-circle-check agpr-canvasLoadingPanel-iconComplete"></i>
                                        } @else {
                                            <div
                                                [agprLoading]="true"
                                                [loadingSmallIndicator]="true"
                                                class="agpr-canvasLoadingPanel-spinner"
                                            ></div>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </div>
            }
        }
    </div>
    <ng-template #takeOverFooterLeft>
        <agpr-button
            id="agpr_canvasLoadingPanel_cancel"
            [style]="buttonTypes.secondary"
            label="cancel"
            (click)="closeDialog()"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
